import { localStorage } from "@prismicio/editor-support/DOM"
import { z } from "zod"

import {
  getAnalyticsSessionId,
  refreshSessionID,
  SEGMENT_DEMO_CONTENT_GROUP,
} from "./analytics"

export function trackDemoCta(
  text: string,
  args: {
    url?: string
    position: "demo banner" | "get started modal" | "end of tour modal"
    type: "primary" | "secondary" | "tertiary"
  },
) {
  const payload = {
    ctaText: text,
    ctaUrl: args.url,
    ctaPosition: args.position,
    ctaType: args.type,
  }

  trackDemoEvent("CTA Clicked", payload)

  if (args.url?.includes("signup")) {
    trackDemoEvent("Sign Up CTA Clicked", payload)
    // Send specific event to LinkedIn since we cant send trough Segment
    window.lintrk?.("track", { conversion_id: 12947916 })
  }
}

export function trackDevFileViewed(path: string) {
  const key = `$$-demo-dev-file-viewed-${path.replace(/\//g, "-")}-triggered`
  const hasTriggeredBefore = localStorage.readJSON(key, z.boolean())
  if (hasTriggeredBefore) return

  trackDemoEvent("Dev file viewed", { path })
  localStorage.write(key, "true")
}

export function trackTourClosed(args: { stepIndex: number | undefined }) {
  trackDemoEvent("Interactive Demo Closed", {
    stepIndex: args.stepIndex,
  })
}

export function trackTourStart() {
  trackTourStep("Start tour")
}

export function trackTourStepNewSlice() {
  trackTourStep("New slice")
}

export function trackTourStepAddContent() {
  trackTourStep("Add content")
}

export function trackTourStepFullPagePreview() {
  trackTourStep("Full page preview")
}

export function trackTourStepReorder() {
  trackTourStep("Reorder")
}

export function trackTourComplete() {
  trackTourStep("Complete tour")
}

function trackTourStep(stepName: string) {
  const key = `$$-demo-tour-step-${stepName
    .toLowerCase()
    .replace(/ /g, "-")}-triggered`
  const hasTriggeredBefore = localStorage.readJSON(key, z.boolean())
  if (hasTriggeredBefore) return

  trackDemoEvent("Interactive Demo Step Completed", {
    interactiveDemoStep: stepName,
  })
  localStorage.write(key, "true")
}

function trackDemoEvent(name: string, context?: Record<string, unknown>) {
  window.analytics.track(name, {
    contentGroup: SEGMENT_DEMO_CONTENT_GROUP,
    session_id: getAnalyticsSessionId(),
    ...context,
  })
  // TODO: Remove the manual session ID generation once Segment handles it
  // automatically again.
  refreshSessionID()
}
